<template>
  <div class="sidebar-container responsive-height">
    <v-list class="overflow-y-auto">
      <v-list-group
        v-for="item in items"
        :key="item.title"
        v-model="item.active"
        action
        link
        :prepend-icon="item.action"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <router-link :to="item.link" class="text-decoration-none">
            {{ item.title }}
          </router-link>
          </v-list-item-content>
        </template>

        <v-list-item-group>
          <v-list-item
            v-for="(child, index) in item.items" 
            :key="child.title" 
            :to="child.childLink" 
            link
            >
            <v-list-item-content>
              <router-link
              :to="child.childLink" 
                class="text-decoration-none"
              >{{ child.title }}</router-link>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
export default {
  data() {
    
    return {
      items: [
        {
          action: "mdi-view-dashboard",
          title: "Dashboard",
          link: "/dashboard?",
          active: false,
        },
        {
          action: "mdi-wallet-travel",
          title: "Wallet",
          link: "/wallet?",
          active: false,
        },
        {
          action: "mdi-account-outline",
          title: "Profile",
          link: "#",
          active: false,
          items: [
            { title: "Profile & Verification", childLink: "/profile-verify" },
            { title: "Change Password", childLink: "/change-password" },
            { title: "Change Leverage", childLink: "/change-leverage" },
            { title: "Change MT5 Password", childLink: "/change-mt5-password" },
            { title: "Payment Information", childLink: "/bank-information" },
          ],
        },
        {
          action: "mdi-signal",
          title: "MT5 Accounts",
          link: "/mt5-accounts?tab=1",
          active: false,
        },
        {
          action: "mdi-trending-up",
          title: "Tradings",
          link: "/trading-details?tab=1",
          active: false,
        },
        {
          action: "mdi-currency-usd",
          title: "Invest",
          link: "/mt5-accounts?tab=?",
          active: false,
          items: [
            { title: "My Investor Accounts", childLink: "/mt5-accounts?tab=3" },
            { title: "Open Investor Account", childLink: "/create-investor-account" },
          ],
        },
        {
          action: "mdi-account-tie-outline",
          title: "Manager",
          link: "/mt5-accounts?tab=4",
          active: false,
          items: [
            { title: "My Manager Accounts", childLink: "/mt5-accounts?tab=4" },
            { title: "Create Manager Account", childLink: "/create-manager-account" },
          ],
        },
        {
          action: "mdi-chat-outline",
          title: "Support",
          link: "/support?",
          active: false,
        },
        {
          action: "mdi-clock-time-twelve-outline",
          title: "FAQ",
          link: "/faq?",
          active: false,
        },
        {
          action: "mdi-clock-time-twelve-outline",
          title: "Terms & Conditions",
          link: "/terms-and-condition",
          active: false,
        },
        {
          action: "mdi-chart-timeline-variant",
          title: "Platforms",
          link: "/platform?",
          active: false,
        },
      ],
    };
  },

  mounted() {
    this.setActiveMenu();
  },

  watch: {
    "$route.path": "setActiveMenu",
  },

  methods: {
    setActiveMenu() {
      const currentPath = this.$route.path;
      this.items.forEach((item) => {
        if (item.items) {
          item.active = item.items.some((child) => child.childLink === currentPath);
        } else {
          item.active = item.link === currentPath;
        }
      });
    },
  },

};
</script>

<style scoped>
  .v-list-item__content_main {
    width: 600px !important;
  }
</style>